(function () {
  var COOKIE = 'ke_b2b';
  var LEADGEN_COOKIE = 'ke_b2b_cookie_leadgen';
  var LEADGEN_CAMPAIGN = 'b2b_leadgen_20260305';
  var MAX_AGE = 60 * 60 * 24 * 60;
  var filtered = false;

  function readCookieValue(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function readCookie() {
    return readCookieValue(COOKIE);
  }

  function analyticsState() {
    var shopify = 'unknown';
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (privacy && typeof privacy.currentVisitorConsent === 'function') {
      try {
        var consent = privacy.currentVisitorConsent() || {};
        if (consent.analytics === 'yes' || consent.analytics === 'no') shopify = consent.analytics;
      } catch (error) {}
    }

    var pandectes = 'unknown';
    var layer = window.dataLayer;
    if (Array.isArray(layer)) {
      layer.forEach(function (entry) {
        if (!entry || entry.event !== 'Pandectes_Consent_Update') return;
        if (entry.pandectes_status === 'deny' || entry.pandectes_status === 'revoke') {
          pandectes = 'no';
          return;
        }
        var performance = entry.pandectes_categories && entry.pandectes_categories.C0002;
        if (entry.pandectes_status === 'allow' || performance === 'allow') pandectes = 'yes';
        else if (performance === 'deny') pandectes = 'no';
      });
    }

    if (shopify === 'no' || pandectes === 'no') return 'no';
    if (shopify === 'yes' || pandectes === 'yes') return 'yes';
    return 'unknown';
  }

  function analyticsAllowed() {
    return analyticsState() === 'yes';
  }

  function preferencesState() {
    var shopify = 'unknown';
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (privacy && typeof privacy.currentVisitorConsent === 'function') {
      try {
        var consent = privacy.currentVisitorConsent() || {};
        if (consent.preferences === 'yes' || consent.preferences === 'no') shopify = consent.preferences;
      } catch (error) {}
    }

    var pandectes = 'unknown';
    var layer = window.dataLayer;
    if (Array.isArray(layer)) {
      layer.forEach(function (entry) {
        if (!entry || entry.event !== 'Pandectes_Consent_Update') return;
        if (entry.pandectes_status === 'deny' || entry.pandectes_status === 'revoke') {
          pandectes = 'no';
          return;
        }
        var functional = entry.pandectes_categories && entry.pandectes_categories.C0001;
        if (entry.pandectes_status === 'allow' || functional === 'allow') pandectes = 'yes';
        else if (functional === 'deny') pandectes = 'no';
      });
    }

    if (shopify === 'no' || pandectes === 'no') return 'no';
    if (shopify === 'yes' || pandectes === 'yes') return 'yes';
    return 'unknown';
  }

  function preferencesAllowed() {
    return preferencesState() === 'yes';
  }

  function writeNamedCookie(name) {
    var secure = location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = name + '=1; Max-Age=' + MAX_AGE + '; Path=/; SameSite=Lax' + secure;
  }

  function clearNamedCookie(name) {
    document.cookie = name + '=; Max-Age=0; Path=/; SameSite=Lax';
  }

  function pushAnalyticsEvent(eventName) {
    if (!analyticsAllowed()) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName });
  }

  function writeCookie() {
    var isNew = readCookie() !== '1';
    writeNamedCookie(COOKIE);
    if (!isNew) return;
    pushAnalyticsEvent('ke_b2b_cookie_set');
  }

  function clearCookie() {
    clearNamedCookie(COOKIE);
  }

  function isLeadgenVisit() {
    try {
      var params = new URLSearchParams(window.location.search);
      var path = window.location.pathname.replace(/\/+$/, '');
      return path === '/pages/premium-snacks-mit-ihrem-branding' && params.get('utm_campaign') === LEADGEN_CAMPAIGN;
    } catch (error) {
      return false;
    }
  }

  function writeLeadgenCookie() {
    var isNew = readCookieValue(LEADGEN_COOKIE) !== '1';
    writeNamedCookie(LEADGEN_COOKIE);
    if (!isNew) return;
    pushAnalyticsEvent('ke_b2b_cookie_leadgen');
  }

  function clearLeadgenCookie() {
    clearNamedCookie(LEADGEN_COOKIE);
  }

  function pandectesDecision() {
    var layer = window.dataLayer;
    if (!Array.isArray(layer)) return 'unknown';
    var decision = 'unknown';

    layer.forEach(function (entry) {
      if (!entry || entry.event !== 'Pandectes_Consent_Update') return;
      if (entry.pandectes_status === 'deny' || entry.pandectes_status === 'revoke') {
        decision = 'deny';
        return;
      }

      var categories = entry.pandectes_categories || {};
      var optional = Object.keys(categories).filter(function (key) { return key !== 'C0000'; });
      if (entry.pandectes_status === 'allow' || optional.some(function (key) { return categories[key] === 'allow'; })) {
        decision = 'allow';
        return;
      }
      if (optional.length && optional.every(function (key) { return categories[key] === 'deny'; })) {
        decision = 'deny';
      }
    });

    return decision;
  }

  function shopifyDecision() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.currentVisitorConsent !== 'function') return 'unknown';

    var consent;
    try {
      consent = privacy.currentVisitorConsent() || {};
    } catch (error) {
      return 'unknown';
    }

    var decided = [consent.preferences, consent.marketing, consent.analytics].filter(function (value) {
      return value === 'yes' || value === 'no';
    });
    if (!decided.length) return 'unknown';
    return decided.indexOf('yes') !== -1 ? 'allow' : 'deny';
  }

  function consentDecision() {
    var shopify = shopifyDecision();
    var pandectes = pandectesDecision();
    if (shopify === 'deny' || pandectes === 'deny') return 'deny';
    if (shopify === 'allow' || pandectes === 'allow') return 'allow';
    return 'unknown';
  }

  function applyCookie(decision) {
    if (decision === 'deny' || preferencesState() === 'no') {
      clearCookie();
      clearLeadgenCookie();
      return;
    }

    if (!preferencesAllowed()) return;

    var account = window.__keB2BAccount;
    if (account === false) {
      clearCookie();
    } else if (account === true) {
      writeCookie();
    }

    if (isLeadgenVisit()) writeLeadgenCookie();
  }

  function wantsB2B() {
    return readCookie() === '1';
  }

  function marketingAllowed() {
    var shopify = 'unknown';
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (privacy && typeof privacy.currentVisitorConsent === 'function') {
      try {
        var consent = privacy.currentVisitorConsent() || {};
        if (consent.marketing === 'yes' || consent.marketing === 'no') shopify = consent.marketing;
      } catch (error) {}
    }

    var pandectes = 'unknown';
    var layer = window.dataLayer;
    if (Array.isArray(layer)) {
      layer.forEach(function (entry) {
        if (!entry || entry.event !== 'Pandectes_Consent_Update') return;
        if (entry.pandectes_status === 'deny' || entry.pandectes_status === 'revoke') {
          pandectes = 'no';
          return;
        }
        var targeting = entry.pandectes_categories && entry.pandectes_categories.C0003;
        if (entry.pandectes_status === 'allow' || targeting === 'allow') pandectes = 'yes';
        else if (targeting === 'deny') pandectes = 'no';
      });
    }

    if (shopify === 'no' || pandectes === 'no') return false;
    return shopify === 'yes' || pandectes === 'yes';
  }

  var ipregistryEnabled = false;

  function lookupCompany() {
    if (!ipregistryEnabled) return;
    var apiKey = window.__keIpRegistryKey;
    if (!apiKey || wantsB2B() || window.__keB2BAccount !== null || !marketingAllowed()) return;

    try {
      if (sessionStorage.getItem('ke_ipregistry') === '1') return;
      sessionStorage.setItem('ke_ipregistry', '1');
    } catch (error) {
      return;
    }

    var url = 'https://eu.api.ipregistry.co/?key=' + encodeURIComponent(apiKey) + '&fields=company.type';
    fetch(url, { credentials: 'omit', cache: 'no-store' })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (data) {
        if (!data || !data.company || data.company.type !== 'business') return;
        if (window.__keB2BAccount === false) return;
        writeCookie();
        if (!document.documentElement.classList.contains('ke-b2b')) {
          document.documentElement.classList.add('ke-b2b');
          reloadOnce();
        }
      })
      .catch(function () {});
  }

  function hideForAudience(audience, b2b) {
    return (audience === 'b2b' && !b2b) || (audience === 'b2c' && b2b);
  }

  function filterSlideshow(carousel, b2b) {
    var slides = Array.from(carousel.querySelectorAll(':scope > .slideshow__slide'));
    var dots = carousel.querySelector('page-dots');
    var dotButtons = dots ? Array.from(dots.children) : [];

    slides.forEach(function (slide, index) {
      var audience = slide.getAttribute('data-ke-audience') || 'all';
      if (!hideForAudience(audience, b2b)) return;
      slide.remove();
      if (dotButtons[index]) dotButtons[index].remove();
    });

    var remaining = Array.from(carousel.querySelectorAll(':scope > .slideshow__slide'));
    remaining.forEach(function (slide, index) {
      slide.classList.toggle('is-selected', index === 0);
    });

    if (dots) {
      Array.from(dots.children).forEach(function (button, index) {
        button.setAttribute('aria-current', index === 0 ? 'true' : 'false');
      });
    }

    if (remaining.length <= 1) {
      var controls = carousel.querySelector('.slideshow__controls');
      if (controls) controls.remove();
      var slideshow = carousel.closest('.slideshow');
      if (slideshow) slideshow.classList.remove('slideshow--multiple-slides');
    }
  }

  function filterAudiences() {
    if (filtered || (window.Shopify && window.Shopify.designMode)) return;
    filtered = true;

    var b2b = document.documentElement.classList.contains('ke-b2b');
    document.querySelectorAll('slideshow-carousel').forEach(function (carousel) {
      filterSlideshow(carousel, b2b);
    });

    document.querySelectorAll('[data-ke-audience]').forEach(function (element) {
      if (element.classList.contains('slideshow__slide')) return;
      if (!hideForAudience(element.getAttribute('data-ke-audience'), b2b)) return;
      var section = element.closest('.shopify-section');
      if (section) section.remove();
      else element.remove();
    });
  }

  function reloadOnce() {
    try {
      if (sessionStorage.getItem('ke_b2b_sync') === '1') return false;
      sessionStorage.setItem('ke_b2b_sync', '1');
    } catch (error) {}
    location.reload();
    return true;
  }

  function reconcile() {
    if (window.Shopify && window.Shopify.designMode) return;

    if (window.__keB2BAccount === false) clearCookie();

    var decision = consentDecision();
    if (decision === 'unknown') {
      document.documentElement.classList.toggle('ke-b2b', wantsB2B());
      filterAudiences();
      return;
    }

    var before = document.documentElement.classList.contains('ke-b2b');
    applyCookie(decision);
    var after = wantsB2B();
    document.documentElement.classList.toggle('ke-b2b', after);

    if (before !== after) {
      if (reloadOnce()) return;
    } else {
      try { sessionStorage.removeItem('ke_b2b_sync'); } catch (error) {}
    }

    filterAudiences();
    lookupCompany();
  }

  function watchPandectes() {
    var layer = window.dataLayer = window.dataLayer || [];
    if (layer.__keWrapped) return;
    var original = layer.push;
    layer.push = function () {
      var result = original.apply(this, arguments);
      for (var i = 0; i < arguments.length; i++) {
        var entry = arguments[i];
        if (entry && entry.event === 'Pandectes_Consent_Update') reconcile();
      }
      return result;
    };
    layer.__keWrapped = true;
  }

  watchPandectes();
  reconcile();
  document.addEventListener('visitorConsentCollected', reconcile);

  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {
      reconcile();
    });
  }
})();
